import React, { Component, Fragment } from "react";
import {
  SelectionFiltersHolder,
  CollapseHolder,
} from "./Styles/selectionFiltersStyle";
import "react-dates/lib/css/_datepicker.css";
import moment from "moment";
import {
  Icon,
  Collapse,
  Row,
  Col,
  Input,
  DatePicker,
  Divider,
  Select,
  Button,
  Form,
  Tooltip,
  Checkbox,
} from "antd";
import Colors from "../themes/Colors";
import UserRoleEnum from "../constants/UserRoleEnum";
import { hasAccessRole, getMinimunByCurrency } from "../services/utils";
import { Trans, withTranslation } from "react-i18next";
import { ProgrammaticSvg } from "../images/customIcons/ProgrammaticSvg";
import { TraditionalSvg } from "../images/customIcons/TraditionalSvg";
import { updatePriceCartByDiscountDisplay } from "../services/display";
import countriesEnum from "../constants/CountriesEnum";
import VerifiedAgencyInfoModal from "./VerifiedAgencyInfoModal";
import { isApprovedPaymentStatus } from "../services/campaignManager";
import HelpTooltipIcon from "./customComponents/HelpIcon/HelpTooltipIcon";
import { HelpIcon } from "./customComponents/HelpIcon/HelpTooltipIcon";

const { Option } = Select;

const Panel = Collapse.Panel;

const { RangePicker } = DatePicker;

const ProgramaticIcon = (props) => (
  <Icon component={ProgrammaticSvg} {...props} />
);

const TraditionalIcon = (props) => (
  <Icon component={TraditionalSvg} {...props} />
);

class SelectionFiltersComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: false,
      errors: {},
      verifiedAgencyError: null,
    };
    this.props.setCountries([]);
  }

  toggleShowPanel = () => {
    this.setState((prevState) => ({
      showPanel: !prevState.showPanel,
    }));
  };

  async handlePriceChange(price) {
    await this.setState({ price });
    this.props.setPrice(price);
  }

  // Limit traditional campaigns to a week for non verified agencies
  validateDates = (dates) => {
    const { user, programmatic, t } = this.props;
    const isUnverifiedAgency =
      user &&
      user.company &&
      user.company.type === "agency" &&
      !user.company.is_verified;
    const validDates = dates && dates.length > 1;
    const isSuperUser =
      user &&
      user.roles &&
      (user.roles.includes(UserRoleEnum.superAdmin) ||
        user.roles.includes(UserRoleEnum.superModeratorAgency));
    if (
      isUnverifiedAgency &&
      validDates &&
      programmatic === "traditional" &&
      !isSuperUser
    ) {
      const diff = dates[1].diff(dates[0], "days");
      if (diff > 7) {
        this.setState({
          verifiedAgencyError: t(
            "The maximun duration of a traditional campaign for non-verfied agencies is limited to a week.",
          ),
        });
        this.showVerifiedAgencyModal();
        return false;
      }
    }

    const isUnverifiedMediaCompany =
      user &&
      user.company &&
      user.company.type === 'media' &&
      !user.company.is_verified;
    const userCompanyId = user.company_id != null ? user.company_id : (user.company && user.company.id);
    const hasExternalScreens =
      this.props.cart &&
      this.props.cart.some(display => {
        const displayCompanyId = display.company_id
          ? display.company_id
          : display.company && display.company.id;
        if (displayCompanyId == userCompanyId) return false;
        const displayHoldingId = display.holding_id ? display.holding_id : display.company && display.company.holding_id;
        const isHoldingDisplay = user.roles && user.roles.includes('holding-member') && user.holding && user.holding.id === displayHoldingId;
        return !isHoldingDisplay;
      });

    if (
      isUnverifiedMediaCompany &&
      validDates &&
      programmatic === "traditional" &&
      hasExternalScreens
    ) {
      const diff = dates[1].diff(dates[0], "days");
      if (diff >= 7) {
        this.setState({
          verifiedAgencyError: t("Unverified media company traditional limit"),
        });
        this.showVerifiedAgencyModal();
        return false;
      }
    }

    return true;
  };

  handleDateChange = (dateStrings) => {
    if (!this.validateDates(dateStrings)) return;

    let startDate = dateStrings[0];
    let endDate = dateStrings[1];

    //condition when press "x" to delete
    if (!startDate && !endDate) {
      const today = new Date();
      startDate = moment(today).add(-1, "d");
      endDate = moment(today).add(30, "d");
    }

    const { setDates } = this.props;
    startDate = moment(startDate);
    endDate = moment(endDate);
    setDates(
      startDate && startDate.format("YYYY-MM-DD"),
      endDate && endDate.format("YYYY-MM-DD"),
    );
  };

  formatDate = (date) => {
    if (date && date.includes("-")) return moment(date);
    return moment();
  };

  showVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: true });
  };

  hideVerifiedAgencyModal = () => {
    this.setState({ isVerifiedAgencyModalVisible: false });
  };

  async handleShowsPerDayChange(showsPerDay) {
    await this.setState({ showsPerDay });
    this.props.setShowsPerDayMin(showsPerDay);
  }

  componentDidMount() {
    this.props.getConversionRates();
    if (
      this.props.client &&
      this.props.client.id 
      // (!this.props.brands || this.props.brands.length === 0)
    ) {
      this.props.getBrands(this.props.client.id);
    }
  }

  componentDidUpdate(nextProps) {
    if (
      this.props.programmatic !== nextProps.programmatic ||
      this.props.isGuaranteed !== nextProps.isGuaranteed ||
      this.props.currency !== nextProps.currency ||
      this.props.campaignCurrency !== nextProps.campaignCurrency
    ) {
      this.checkMinimunBudget(this.props.amountBudget);
    }
    if (this.props.countries !== nextProps.countries) {
      this.props.refreshDisplays();
    }

    if (
      this.props.programmatic === "traditional" &&
      (this.props.date_to != nextProps.date_to ||
        this.props.date_from != nextProps.date_from)
    ) {
      updatePriceCartByDiscountDisplay(
        this.props.displays,
        this.props.date_from,
        this.props.date_to,
        this.props.updatePriceCartByDiscount,
      );
    }
    if (
      !this.validateDates([
        moment(this.props.date_from),
        moment(this.props.date_to),
      ])
    ) {
      this.handleDateChange([
        moment(this.props.date_from),
        moment(this.props.date_from).add(6, "days"),
      ]);
    }

    if (this.props.user != nextProps.user) {
      this.props.setBudget(this.validateBudget(this.props.amountBudget));
    }
  }

  renderIdentificationClients = () => {
    if (this.props.clients && this.props.clients.length > 0) {
      return this.props.clients.map((client) => {
        return (
          <Option key={client.id} value={client.id}>
            {client.name}
          </Option>
        );
      });
    }
  };

  renderIdentificationBrands = () => {
    if (this.props.brands && this.props.brands.length > 0) {
      return this.props.brands.map((brand) => {
        return (
          <Option key={brand.id} value={brand.id}>
            {brand.name}
          </Option>
        );
      });
    }
  };

  renderIdentificationCountries = () => {
    return countriesEnum.map((country) => {
      return (
        <Option key={country.key} value={country.key}>
          {country.name}
        </Option>
      );
    });
  };

  renderIdentificationDsp = () => {
    const { dsps, isGuaranteed } = this.props;
    let listDsp = [...dsps];
    if (isGuaranteed) {
      listDsp = listDsp.filter(
        (item) => item.allow_guaranteed,
      );
    }
    listDsp.unshift({ id: null, name: "Latinad", exchange: "latinad" });
    return listDsp.map((dsps) => {
      return (
        <Select.Option default={dsps.id == null} key={dsps.id} value={dsps.id}>
          {dsps.name}{" "}
          <span style={{ color: "rgb(135 135 135)" }}>{dsps.exchange}</span>
        </Select.Option>
      );
    });
  };

  changeClient = (clientSelect) => {
    const client = this.props.clients.find(
      (client) => client.id === clientSelect.key,
    );
    this.props.setClient(client);
    this.props.setBrands(client.brands);
  };
  changeBrand = (brandSelect) => {
    this.props.setBrand(
      this.props.brands.find((brand) => brand.id === brandSelect.key),
    );
  };

  // updateBudget = () => {
  //   this.props.setBudget(this.validateBudget(this.props.amountBudget));
  // };

  changeDsp = (dspSelect) => {
    const dsp = this.props.dsps.find((dsp) => dsp.id === dspSelect.key);
    this.props.setDsp(dsp);
    if (this.props.editCampaignActive) {
      if (dsp && dsp.id) {
        this.props.convertAndSetBudget("USD");
      } else {
        this.props.convertAndSetBudget(this.props.currentCampaign.currency);
      }
    }
  };

  changeCountries = (countriesSelected) => {
    this.props.setCountries(countriesSelected);
  };

  // Limit programmatic campaign to 5000USD budget for non verified agencies
  validateBudget = (budget) => {
    const { user, programmatic, currency, conversionRates, t } = this.props;
    const isUnverifiedAgency =
      user &&
      user.company &&
      user.company.type === "agency" &&
      !user.company.is_verified;
    const conversionRate = conversionRates.find(
      (rate) => rate.currency === currency,
    );
    const maxBudget = 5000 * conversionRate.rate;
    const overBudget = budget > maxBudget;
    const isSuperUser =
      user &&
      user.roles &&
      (user.roles.includes(UserRoleEnum.superAdmin) ||
        user.roles.includes(UserRoleEnum.superModeratorAgency));
    if (
      isUnverifiedAgency &&
      programmatic === "programmatic" &&
      overBudget &&
      !isSuperUser
    ) {
      this.setState({
        verifiedAgencyError: t(
          "The maximum budget for non verified agencies is 5000 USD a month",
        ),
      });
      this.showVerifiedAgencyModal();
      return Math.floor(maxBudget);
    }
    return budget;
  };

  handleAmountChange(e) {
    let rawValue = e.target.value;
    rawValue = rawValue.replace(/[^0-9.]/g, "");
    const parts = rawValue.split(".");
    if (parts.length > 2) {
      rawValue = parts[0] + "." + parts.slice(1).join("");
    }
    if (rawValue.includes(".")) {
      const decimalPart = rawValue.split(".")[1];
      if (decimalPart && decimalPart.length > 2) {
        rawValue = parts[0] + "." + decimalPart.slice(0, 2);
      }
    }
    let numericValue = rawValue === "" ? null : Number(rawValue);
    const MAX_VALUE = 999999999999.99;
    if (numericValue !== null) {
      numericValue = Math.floor(numericValue * 100) / 100;
      if (numericValue > MAX_VALUE) {
        numericValue = MAX_VALUE;
      }
    }
    const validatedBudget = this.validateBudget(numericValue);
    this.checkMinimunBudget(validatedBudget);
    this.props.setBudget(validatedBudget);
    e.target.value = rawValue;
  }

  checkMinimunBudget(num) {
    const errors = {};
    const {
      t,
      currency,
      programmatic,
      campaignCurrency,
      editCampaignActive,
    } = this.props;

    const usedCurrency = editCampaignActive ? campaignCurrency : currency;

    let min = getMinimunByCurrency(usedCurrency);
    if (num < min && programmatic === "programmatic") {
      errors["budget"] =
        t("The minimum purchase price is") + " " + usedCurrency + " " + min;
    }
    if (JSON.stringify(errors) !== JSON.stringify(this.state.errors)) {
      this.setState({ errors });
    }
  }

  searchCountry = (input, option) =>
    [
      option.key.toLowerCase(), // filter by ISO code
      option.props.children.toLowerCase(), // filter by name
      option.props.children
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, ""), // filter by name w/o diacritics
    ].some((f) => f.includes(input.toLowerCase()));

  render() {
    const {
      t,
      user,
      date_from,
      date_to,
      programmatic,
      currency,
      amountBudget,
      isCircuit,
      dsp,
      isSuperUser,
      acceptedGuaranteedTerms,
      setAcceptedGuaranteedTerms,
      editCampaignActive,
      currentCampaign,
    } = this.props;
    let isQuote = window.location.href.includes("external_dsp_id");
    const { errors } = this.state;

    if (editCampaignActive && isApprovedPaymentStatus(currentCampaign)) {
      return null;
    }

    // check when initialize view
    if (
      amountBudget < getMinimunByCurrency(currency) &&
      !errors["budget"] &&
      programmatic === "programmatic"
    ) {
      this.checkMinimunBudget(amountBudget);
    }
    let isAgency = false;

    if (
      user &&
      hasAccessRole(user.roles, [
        UserRoleEnum.agencyMember,
        UserRoleEnum.companyMember,
      ])
    ) {
      isAgency = true;
    }

    const customPanelStyle = {
      background: Colors.snow,
      borderRadius: "16px",
      border: 0,
      overflow: "hidden",
    };

    function disabledDate(current) {
      // Can not select days before today
      return (
        current &&
        current <
          moment()
            .subtract(1, "days")
            .endOf("day")
      );
    }

    return (
      <CollapseHolder>
        <Collapse
          activeKey={+this.state.showPanel}
          bordered={false}
          onChange={this.toggleShowPanel}
          expandIconPosition="right"
          style={{
            borderRadius: "16px",
            marginBottom: "3px",
            border: `1px solid ${Colors.borderStrong}`,
          }}
        >
          <Panel
            header={
              <span style={{ fontWeight: 600 }}>
                {t("General configuration")}
              </span>
            }
            key="1"
            style={customPanelStyle}
          >
            <SelectionFiltersHolder>
              <Row gutter={20} type="flex">
                <Fragment>
                  <Row type="flex" align="middle" className="typePurchase">
                    <Button
                      size="large"
                      type="primary"
                      ghost
                      value="programmatic_pmp"
                      className={
                        this.props.programmatic === "programmatic" &&
                        !this.props.isGuaranteed
                          ? "purchaseTypeButtonSelected"
                          : "purchaseTypeButton"
                      }
                      onClick={async () => {
                        await this.props.setProgrammatic("programmatic");
                        await this.props.setIsGuaranteed(false);
                        this.props.setDsp(null);
                        this.props.refreshDisplays("programmatic");
                        this.props.cleanAudience();
                        this.props.removeDisplaysCart();
                      }}
                    >
                      <ProgramaticIcon />
                      {t("Programmatic PMP")}
                    </Button>
                    <Button
                      size="large"
                      type="primary"
                      ghost
                      value="programmatic_pg"
                      className={
                        this.props.programmatic === "programmatic" &&
                        this.props.isGuaranteed
                          ? "purchaseTypeButtonSelected"
                          : "purchaseTypeButton"
                      }
                      onClick={async () => {
                        await this.props.setProgrammatic("programmatic");
                        await this.props.setIsGuaranteed(true);
                        this.props.refreshDisplays("programmatic");
                        if (this.props.dsps && this.props.dsps.length > 0) {
                          const guaranteedDsps = this.props.dsps.filter(
                            (dsp) => dsp.allow_guaranteed,
                          );
                          if (guaranteedDsps.length > 0) {
                            const dv360Dsp = guaranteedDsps.find((dsp) =>
                              dsp.name.includes("DV360"),
                            );
                            this.props.setDsp(dv360Dsp || guaranteedDsps[0]);
                          }
                        }
                        this.props.cleanAudience();
                        this.props.removeDisplaysCart();
                      }}
                    >
                      <ProgramaticIcon />
                      {t("Programmatic PG")}
                    </Button>
                    <Button
                      size="large"
                      type="primary"
                      ghost
                      value="traditional"
                      className={
                        this.props.programmatic === "traditional"
                          ? "purchaseTypeButtonSelected"
                          : "purchaseTypeButton"
                      }
                      onClick={async () => {
                        await this.props.setProgrammatic("traditional");
                        await this.props.setIsGuaranteed(false);
                        this.props.setDsp(null);
                        this.props.refreshDisplays("traditional");
                        this.props.cleanAudience();
                        this.props.removeDisplaysCart();
                        if (!isSuperUser) this.props.setDsp(null);
                      }}
                    >
                      <TraditionalIcon />
                      {t("Traditional")}
                    </Button>
                  </Row>
                  {this.props.isGuaranteed && (
                    <Row style={{ marginTop: "15px", marginBottom: "15px" }}>
                      <Col span={24}>
                        <div
                          style={{
                            backgroundColor: Colors.extraLightPrimary,
                            padding: "12px",
                            borderRadius: "8px",
                            border: `1px solid ${Colors.lightPrimary}`,
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "8px",
                            }}
                          >
                            <Icon
                              type="info-circle"
                              style={{ color: Colors.primaryAccent, marginRight: "8px" }}
                            />
                            <b style={{ color: Colors.secondary, fontSize: "13px" }}>
                              {t("Guaranteed Campaign")}
                            </b>
                          </div>
                          <p
                            style={{
                              fontSize: "11px",
                              lineHeight: "1.4",
                              marginBottom: "10px",
                            }}
                          >
                            {t(
                              "You guarantee the delivery of a defined number of screen appearances on specific dates and times. Inventory is reserved and the campaign takes priority to fulfill the contract, with total predictability.",
                            )}
                          </p>
                          <Checkbox
                            checked={acceptedGuaranteedTerms}
                            onChange={(e) =>
                              setAcceptedGuaranteedTerms(e.target.checked)
                            }
                          >
                            <span style={{ fontSize: "11px" }}>
                              {t(
                                "I have read and accept the terms and conditions of the Guaranteed Campaign.",
                              )}
                            </span>
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  )}
                  <Divider style={{ margin: "20px 0px" }} />
                  <Row type="flex" align="middle" className="noWrap longInput">
                    <span style={{ paddingRight: "5px" }}>
                      {t("Countries")}
                    </span>
                    <span className="inputSelect">
                      <Select
                        allowClear
                        placeholder={t("Select")}
                        style={{ width: "100%" }}
                        mode="multiple"
                        onChange={this.changeCountries.bind(this)}
                        value={[...this.props.countries]}
                        filterOption={this.searchCountry.bind(this)}
                      >
                        {this.renderIdentificationCountries()}
                      </Select>
                    </span>
                  </Row>
                  {isAgency ? (
                    <Fragment>
                      {/* One per row at every width: the panel is ~420px wide on
                          desktop and two halves squeezed the client name. */}
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row type="flex" align="middle" className="noWrap">
                          <span className="inputWidth">{t("Client")}</span>
                          <Select
                            className="inputSelect"
                            labelInValue
                            onChange={this.changeClient.bind(this)}
                            loading={this.props.loadingClients}
                            value={{
                              key:
                                this.props.client && this.props.client.id
                                  ? parseInt(this.props.client.id)
                                  : t("Select"),
                            }}
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.renderIdentificationClients()}
                          </Select>
                          <div className="help-icon">
                            <HelpTooltipIcon
                              href="https://www.youtube.com/watch?v=ouAACPF6syA"
                              tooltip={
                                <Trans
                                  i18nKey="To select a client, you must first create it in the “Clients” section of the CMS and then create the associated brand. Click on the <icon/> to learn how to do it."
                                  components={{
                                    icon: <HelpIcon />,
                                  }}
                                />
                              }
                            />
                          </div>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row type="flex" align="middle" className="noWrap">
                          <span className="inputWidth">{t("Mark")}</span>
                          <Select
                            className="inputSelect"
                            labelInValue
                            onChange={this.changeBrand.bind(this)}
                            loading={this.props.loadingBrands}
                            disabled={this.props.loadingBrands}
                            value={{
                              key:
                                this.props.brand && this.props.brand.id
                                  ? parseInt(this.props.brand.id)
                                  : t("Select"),
                            }}
                            showSearch
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {this.renderIdentificationBrands()}
                          </Select>
                        </Row>
                      </Col>
                    </Fragment>
                  ) : null}
                  <Row
                    type="flex"
                    align="middle"
                    className="noWrap longInputTwo"
                  >
                    <span style={{ paddingBottom: "25px", marginRight: "5px" }}>
                      {t("Budget")}
                    </span>
                    <Form.Item
                      validateStatus={
                        !!errors["budget"] && "error" ? "error" : null
                      }
                      help={errors["budget"]}
                    >
                      <Input
                        type="number"
                        prefix="&nbsp;&nbsp;$"
                        min={10}
                        max={999999999999.99}
                        placeholder="0"
                        className="inputBudget"
                        disabled={this.props.programmatic === "traditional"}
                        value={this.props.amountBudget}
                        onChange={this.handleAmountChange.bind(this)}
                        autoComplete="off"
                      />
                    </Form.Item>
                  </Row>
                  {user &&
                  user.company &&
                  user.company.enable_external_dsp_selector ? (
                    <Row
                      type="flex"
                      align="middle"
                      className="noWrap longInputTwo"
                    >
                      <Tooltip
                        placement="right"
                        style={{ marginBottom: "25px" }}
                        title={<span>{t("info_dsp")}</span>}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end",
                            marginBottom: "25px",
                          }}
                        >
                          DSPs
                          <Icon
                            type="info-circle"
                            style={{
                              marginLeft: "10px",
                              color:
                                !dsp || (dsp && dsp.id == null)
                                  ? "#aaaaaad1"
                                  : Colors.atention,
                            }}
                            theme="filled"
                          />
                        </div>
                      </Tooltip>
                      <Form.Item>
                        <Select
                          disabled={
                            this.props.programmatic === "traditional" ||
                            isQuote ||
                            (this.props.editCampaignActive &&
                              !this.props.isPendingCurrentCampaign)
                          }
                          className="inputSelect"
                          labelInValue
                          onChange={this.changeDsp.bind(this)}
                          loading={this.props.loadingDsp}
                          value={{
                            key: dsp && dsp.id ? parseInt(dsp.id) : "Latinad",
                          }}
                          showSearch
                          filterOption={(input, option) =>
                            option.props.children &&
                            option.props.children[0]
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          {this.renderIdentificationDsp()}
                        </Select>
                      </Form.Item>
                    </Row>
                  ) : null}
                </Fragment>
                <Row type="flex" align="middle" className="noWrap longInput">
                  <span>{t("Dates")}</span>
                  <span className="inputSelect">
                    <RangePicker
                      style={{ width: "100%" }}
                      value={[
                        this.formatDate(date_from),
                        this.formatDate(date_to),
                      ]}
                      onChange={this.handleDateChange}
                      disabledDate={disabledDate}
                    />
                  </span>
                </Row>
              </Row>
            </SelectionFiltersHolder>
          </Panel>
        </Collapse>
        <VerifiedAgencyInfoModal
          isVisible={this.state.isVerifiedAgencyModalVisible}
          hide={this.hideVerifiedAgencyModal}
          message={this.state.verifiedAgencyError}
        ></VerifiedAgencyInfoModal>
      </CollapseHolder>
    );
  }
}
export default withTranslation()(SelectionFiltersComponent);
